import { cloneDeep } from 'lodash';
import request from 'superagent';
const SET_SEARCH_SUGGESTIONS = 'SET_SEARCH_SUGGESTIONS';

const initialStateSearchSuggestions = [];

export default function reducer(state = cloneDeep(initialStateSearchSuggestions), action) {
	switch (action.type) {
		case SET_SEARCH_SUGGESTIONS:
			return action.payload;
		default:
			return state;
	}
}

export function setSearchSuggestions(suggestions){
	return {
		type: SET_SEARCH_SUGGESTIONS,
		payload: suggestions
	}
}

export function handleSuggest(sQuery){
	return dispatch => {
	    request
	      .get('/svc/search/suggest/?q=' + sQuery)
	      .set('Accept', 'application/json')
	      .end((err, res) => {
	        if (!err && res.statusCode === 200 ){
	          return dispatch( setSearchSuggestions(res.body) );
	        }
	    });
	}
}


// WEBPACK FOOTER //
// ./src/modules/search_suggestions.js